import React from "react";
import { IncDreWrap } from "./IncrementDecrementInput.style";

export default class IncrementDecrementInput extends React.Component {
  state = {
    min: this.props.min ? this.props.min : 0,
    max: this.props.max ? this.props.max : this.props.max === 0 ? 0 : 10,
    value: this.props.value,
    disabled: this.props.disabled ? this.props.disabled : false,
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.disabled != this.props.disabled) {
      this.setState({
        disabled: this.props.disabled,
      });
    }
    if (prevProps.value != this.props.value) {
      this.setState({
        value: this.props.value,
      });
    }
    if (prevProps.min != this.props.min) {
      this.setState({
        min: this.props.min,
      });
    }
    if (prevProps.max != this.props.max) {
      this.setState({
        max: this.props.max,
      });
    }
  };

  handleChange = (e) => {
    this.props.handleChange(e);
    // this.setState(
    //   {
    //     value: e,
    //   },

    // );
  };

  decrement() {
    if (!this.state.disabled) {
      let { value, min } = this.state;
      value -= parseInt(this.props.step);

      if (value < min) {
        value = min;
      }

      this.handleChange(value);
    }
  }
  increment() {
    if (!this.state.disabled) {
      let { value, max } = this.state;
      value += parseInt(this.props.step);

      if (value > max) {
        value = max;
      }

      this.handleChange(value);
    }
  }
  render() {
    return (
      <IncDreWrap>
        <div className={this.state.disabled ? "incdecDisable" : ""}>
          <div
            onClick={() => {
              this.decrement();
            }}
            className={
              this.state.value == this.state.min
                ? "beforeIn indisabled"
                : "beforeIn"
            }
          >
            {"-"}
          </div>
          <input
            readonly={true}
            type="number"
            value={this.state.value}
            disabled={this.state.disabled}
          />
          <div
            onClick={() => {
              this.increment();
            }}
            className={
              this.state.value == this.state.max
                ? "afterIn indisabled"
                : "afterIn"
            }
          >
            {"+"}
          </div>
        </div>
      </IncDreWrap>
    );
  }
}
